import React from "react";
import { GET } from "Common/api";
import UserInfoHeading from "../Info";

class UserInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const personalInfo = await GET(
      `v1/users/${this.props.personalId}/public-info/`,
    );
    this.setState({ personalInfo });
  }

  render() {
    const { pageTitle, personalId } = this.props;
    const { personalInfo } = this.state;

    if (!personalInfo) {
      return <div />;
    }
    return (
      <UserInfoHeading
        pageTitle={pageTitle}
        userData={{ ...personalInfo, personalId }}
      />
    );
  }
}

export default UserInfoContainer;
